import { PinIcon } from "components/atoms/Icon";
import { Header, Paragraph } from "components/atoms/Typography";
import RemodelBuildingsView from "pages/PortfolioPage/HeaderComponents/RemodelBuildingsView";
import { getDisplayInfo } from "utils/formatting";
import BuildingTags from "../BuildingTags";
import BuildingHeaderActionsError from "./BuildingHeaderActionsError";
import BuildingName from "./BuildingName";
import styles from "./BuildingPageHeaderError.module.scss";

interface BuildindPageHeaderErrorProps {
    buildingModel: Building;
}

function BuildingPageHeaderError({ buildingModel }: BuildindPageHeaderErrorProps) {
    const addressComponents = [
        buildingModel.streetAddress,
        buildingModel.city,
        buildingModel.stateProvince,
        buildingModel.postalZipCode,
        buildingModel.country,
    ].filter((i) => i !== null);
    const fullAddress = addressComponents.join(", ");

    const { formatFunction } = getDisplayInfo("dataCoverage");
    const dataCoverage: DataCoverage = {
        dataCoverage: buildingModel.modellingStatus as DataCoverageEnum,
        energyType: buildingModel.energyType as EnergyTypeEnum,
        energyTypeFromEquipmentData: buildingModel.energyTypeFromEquipmentData as EnergyTypeEnum,
        energyTypeFromUtilityData: buildingModel.energyTypeFromUtilityData as EnergyTypeEnum,
        equipmentDataHasSizeAndYear: buildingModel.equipmentDataHasSizeAndYear,
        equipmentDataUploaded: buildingModel.equipmentDataUploaded,
        modellingStatus: buildingModel.modellingStatus as ModellingStatus,
        utilityDataUploaded: buildingModel.utilityDataUploaded,
    };

    return (
        <div>
            <div className="baseline-building-report-header">
                <div className="baseline-building-report-header--building-info">
                    <div className="building-name-and-tags">
                        <BuildingName
                            buildingName={buildingModel.buildingName}
                            buildingModelUid={buildingModel.buildingModelUid}
                        />
                        {formatFunction(dataCoverage)}
                        <BuildingTags
                            buildingModelUid={buildingModel.buildingModelUid}
                            defaultTags={buildingModel.tags}
                        />
                    </div>
                    <div className="building-header-property-and-location">
                        <Paragraph
                            style={{
                                color: "var(--audette-gray-500)",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <PinIcon />
                            <span style={{ marginLeft: "4px" }}>{fullAddress}</span>
                        </Paragraph>
                    </div>
                </div>

                <BuildingHeaderActionsError />
            </div>
            <div className={styles.pageContainer}>
                <Header size="medium">
                    There is an error with this building, you may try remodelling it. If this does not work, please
                    contact Audette.
                </Header>
                <div className={styles.button}>
                    <RemodelBuildingsView selectedBuildingModelUids={[buildingModel.buildingModelUid]} />
                </div>
            </div>
        </div>
    );
}

export default BuildingPageHeaderError;
